import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SanofiLogo from '../SanofiLogo/SanofiLogo';

export const LoginPage = () => {
  const { lang } = useParams<{ lang: string }>();
  const navigate = useNavigate();

  if (!lang) return <></>;

  React.useEffect(() => {
    navigate(`/${lang}/home`, { replace: true });
  }, [navigate, lang]);

  return (
    <div className="login-page">
      <div className="login-page__container">
        <div className="login-page__header">
          <SanofiLogo />
          <h1>Redirecting to home...</h1>
        </div>
      </div>
    </div>
  );
};
